import React from "react";
import styled from "styled-components";

export const Button = React.memo(({type, children, className, onClick}) => {
    let BtnComponent;

    switch (type) {
        case 'close':
            BtnComponent = CloseBtn;
            break;
        case 'serviceBtn':
            BtnComponent = ServiceBtn;
            break;
        case 'countBtn':
            BtnComponent = CountBtn;
            break;
        case 'cautionBtn':
            BtnComponent = CautionBtn;
            break;
        default:
            BtnComponent = DefaultBtn;
            break;
    }

    return (
        <BtnComponent
            className={className}
            onClick={onClick}
        >
            {children}
        </BtnComponent>
    );
});

const DefaultBtn = styled.button``;

const CloseBtn = styled(DefaultBtn)`
    position: absolute;
    top: 10px;
    right: 10px;
    color: #418ded;
    font-size: 31px;
`;

const ServiceBtn = styled(DefaultBtn)`
    width: calc(49% - 5px);
    font-size: 20px;
    font-weight: bold;
    height: 60px;
    vertical-align: middle;
    box-sizing: border-box;

    &.btn_flat {
        border: 0;
        color: #fff;
        background-color: #418ded;

        &:hover {
            background: #3281ed;
        }
    }

    &.btn_border {
        margin-left: 10px;
        border: 2px solid #418ded;
        color: #418ded;
        background-color: #fff;

        &:hover {
            background: #f8f8f8;
        }
    }
`;

const CountBtn = styled(DefaultBtn)`
    &.btn_cnt_minus{
        left: 0;
    }
    &.btn_cnt_plus{
        right: 0;
    }
    &.btn_cnt_minus,
    &.btn_cnt_plus{
        position: absolute;
        top: 0;
        font-size: 21px;
        width: 28px;
        height: 30px;
        border: 1px solid #666;
        color: #666;
        background-color: #fff;
        vertical-align: middle;
        letter-spacing: 0;
        cursor: pointer;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box !important;
        border-left: 0;
        border-right: 0;
    }
`;

const CautionBtn = styled(DefaultBtn)`
    font-size: 12px;
    width: 82px;
    height: 30px;
    border: 1px solid #999 !important;
    color: #666;
    background-color: #fff;
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box !important;

    &:hover{
        background: #f6f6f6;
    }
    i:before{
        font-size: 18px;
        vertical-align: -3px;
    }
`;



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/elementPiece/button.js